import React from 'react';
import { ActionButtonGroup } from '../../shared';
import { useBillingActions, useFlowActions, useStepNavigation } from '../../../context';
import { calculateBillingDates } from '../../../utils';

/**
 * Component that displays the final cancellation confirmation
 * Shows cancellation details and provides final confirmation or back options
 */
const CancelView = () => {
  // Get actions from context
  const { confirmCancellation } = useBillingActions();
  const { keepMembership } = useFlowActions();
  const { goToStep } = useStepNavigation();
  // Calculate end of current billing period using utility
  const { formattedNextBillingDate } = calculateBillingDates();
  return (
    <div className="cancellation-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-3">Please confirm your cancellation.</h5>
        <p className="mb-3">
          Canceling will end your WHOLE Life Club membership and access on <strong>{formattedNextBillingDate}</strong>,
          and no further charges will occur.
        </p>
        <p className="mb-4">
          If you'd prefer to keep your access active, you can go back and change your selection. Otherwise, confirm
          below.
        </p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Keep My Membership',
            onClick: keepMembership,
            color: 'primary',
            size: 'lg'
          }}
          secondaryAction={{
            text: 'Cancel My Membership',
            onClick: confirmCancellation,
            color: 'danger'
          }}
          layout="horizontal"
        />

        <p className="mb-4">
          Thank you for being part of WHOLE Life Club. We're wishing you every success in your journey toward a
          healthier, happier life.
        </p>
      </div>
    </div>
  );
};

export default CancelView;
